"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientSummaryInfo = void 0;
class ClientSummaryInfo {
    constructor() {
        this.note = "";
        this.totalSize = 0;
        this.maxDepth = 0;
        this.directoryCount = 0;
        this.fileCount = 0;
        this.entryCount = 0;
        this.importStates = {
            0: 0,
            1: 0,
            2: 0,
            3: 0,
            4: 0,
            5: 0
        };
    }
}
exports.ClientSummaryInfo = ClientSummaryInfo;
